import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { StateData } from 'shell/models/practice-lists';
import { ItemVM } from 'shell/view-models/item';

interface StateListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (acronym?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
  required?: boolean;
}

const StateListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Stato',
  id = 'state-list',
  required,
}: StateListComponentProps): React.ReactElement => {
  const [list] = useHttpFetch<HttpResponseList<StateData>, Array<ItemVM>>(
    `${__PRACTICE_API_URL__}/pratiche/stato-pratica`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<StateData>>) => {
        const { data } = response;
        return data?.payload.list?.map((item) => ({
          id: item.key?.codiceStatoPratica || '',
          value: item.descrizioneStatoPratica || '',
        }));
      },
    }
  );

  const idTag = `${id}-${label}`;

  const dataList = (list.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {`${label} ${required ? ' *' : ''}`}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {dataList?.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

StateListComponent.displayName = 'State List component';

const StateList = memo(StateListComponent);

export default StateList as typeof StateListComponent;
